import { gql } from '../../utils/helper';

export const updateStoryUpdatedAt = gql`
  mutation updateStoryUpdatedAt($id: String!, $updatedAt: timestamp) {
    update_stories_by_pk(pk_columns: { _id: $id }, _set: { updatedAt: $updatedAt }) {
      _id
    }
  }
`;

export const updateStoryContent = gql`
  mutation UpsertStoryContents($storyContentData: storyContents_insert_input!) {
    contents: insert_storyContents_one(
      object: $storyContentData
      on_conflict: {
        constraint: storyContents_pkey
        update_columns: [
          title
          createdAt
          updatedAt
          description
          active
          order
          format
          group
          layout
          content
          contentHtml
        ]
      }
    ) {
      _id
      active
      content
      contentHtml
      createdAt
      description
      entityId
      format
      group
      layout
      order
      storyId
      title
      type
      updatedAt
      authorId
      contentChartConfig {
        id
        contentId
        storyId
        config
        type
      }
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
    }
  }
`;

export const updateTemplateContent = gql`
  mutation updateTemplateContent($storyContentData: storyTemplateContents_insert_input!) {
    contents: insert_storyTemplateContents_one(
      object: $storyContentData
      on_conflict: {
        constraint: storyTemplateContents_pkey
        update_columns: [title, description, active, order, format, group, layout, content, contentHtml, type]
      }
    ) {
      _id
      active
      authorId
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
      content
      contentHtml
      description
      entityId
      format
      group
      layout
      order
      title
      type
      storyTemplateId
    }
  }
`;

export const getStoryById = gql`
  query getStoryById($id: String!) {
    resource: stories(where: {_id: {_eq: $id}, deletedAt: {_is_null: true}}) {
      _id
      createdAt
      createdBy
      description
      folderId
      entityId
      publicUrl
      state
      title
      authorId
      updatedAt
      paddingTop
      paddingBottom
      publishedAt
      publishedBy
      thumbnail
      updatedBy
      storyKey
      isFollowable
      author {
        title
        _id
        firstName
        lastName
        email
        opengovId
      }
      customColors {
        colorTarget
        colors
        contentType
      }
      customCssCode
      folder {
        publicationId
        id
        title
        publication {
          customCssCode
        }
      }
    }
  }
`;

export const updateStoryCustomColors = gql`
  mutation updateStoryCustomColors($customColors: [storyCustomColors_insert_input!]!) {
    insert_storyCustomColors(
      objects: $customColors
      on_conflict: { constraint: storyCustomColors_pkey, update_columns: colors }
    ) {
      affected_rows
    }
  }
`;

export const updateTemplateCustomColors = gql`
  mutation updateTemplateCustomColors($customColors: [storyTemplateCustomColors_insert_input!]!) {
    insert_storyTemplateCustomColors(
      objects: $customColors
      on_conflict: { constraint: templateCustomColors_pkey, update_columns: colors }
    ) {
      affected_rows
    }
  }
`;

export const updateStory = gql`
  mutation updateStory($id: String!, $data: stories_set_input!) {
    resource: update_stories_by_pk(pk_columns: { _id: $id }, _set: $data) {
      _id
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
      createdAt
      createdBy
      description
      entityId
      paddingBottom
      paddingTop
      publicUrl
      publishedAt
      authorId
      publishedBy
      state
      storyKey
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
      isFollowable
      customColors {
        colorTarget
        colors
        contentType
      }
    }
  }
`;

export const updateTemplate = gql`
  mutation updateTemplate($id: String!, $data: storyTemplates_set_input!) {
    resource: update_storyTemplates_by_pk(pk_columns: { _id: $id }, _set: $data) {
      _id
      authorId
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
      createdAt
      createdBy
      description
      entityId
      paddingBottom
      paddingTop
      publishedAt
      publishedBy
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
      customColors {
        colorTarget
        colors
        contentType
      }
    }
  }
`;

export const getUserByOgId = gql`
  query getUserByOgId($id: Int!) {
    storyUsers(where: { opengovId: { _eq: $id } }) {
      _id
    }
  }
`;

export const removePortalStory = gql`
  mutation removePortalStory($id: String!) {
    delete_portalStory(where: { storyId: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const removeStory = gql`
  mutation removeStory($id: String!) {
    update_stories(where: { _id: { _eq: $id } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
  }
`;

export const removeStoryContent = gql`
  mutation deleteStoryContent($storyContentId: String!) {
    delete_storyContents_by_pk(_id: $storyContentId) {
      _id
    }
  }
`;

export const removeTemplateContent = gql`
  mutation deleteTemplateContent($storyContentId: String!) {
    delete_storyTemplateContents_by_pk(_id: $storyContentId) {
      _id
    }
  }
`;

export const createTemplate = gql`
  mutation createTemplate($data: storyTemplates_insert_input!) {
    template: insert_storyTemplates_one(object: $data) {
      _id
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
      authorId
      createdAt
      createdBy
      customCssCode
      description
      entityId
      paddingBottom
      paddingTop
      publishedAt
      publishedBy
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
    }
  }
`;

export const removeTemplate = gql`
  mutation deleteTemplate($id: String!) {
    delete_storyTemplateContents(where: { storyTemplateId: { _eq: $id } }) {
      affected_rows
    }
    delete_storyTemplates_by_pk(_id: $id) {
      _id
    }
  }
`;

export const getStoryEmbeds = gql`
  query getStoryEmbeds($storyId: String!) {
    storyEmbeds(where: { storyId: { _eq: $storyId } }) {
      embedId
    }
  }
`;

export const removeStoryEmbeds = gql`
  mutation removeStoryEmbeds($storyId: String!) {
    delete_storyEmbeds(where: { storyId: { _eq: $storyId } }) {
      affected_rows
    }
  }
`;

export const insertStoryEmbedsWithEmbedData = gql`
  mutation insertStoryEmbeds($data: [storyEmbeds_insert_input!]!) {
    insert_storyEmbeds(objects: $data, on_conflict: { constraint: storyEmbeds_pkey, update_columns: [] }) {
      affected_rows
    }
  }
`;

export const deleteStoryEmbed = gql`
  mutation deleteStoryEmbed($embedId: uuid!, $storyId: String!) {
    delete_storyEmbeds_by_pk(embedId: $embedId, storyId: $storyId) {
      embedId
      storyId
      createdAt
    }
  }
`;

export const insertStoryEmbeds = gql`
  mutation insertStoryEmbeds($data: [storyEmbeds_insert_input!]!) {
    insert_storyEmbeds(objects: $data) {
      affected_rows
    }
  }
`;
